import { Link } from "react-router-dom";
import { resolveMediaUrl } from "../lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

const getThumb = (media) => {
  if (media.thumbnail_url) return resolveMediaUrl(media.thumbnail_url);
  if (media.media_type === "image") return resolveMediaUrl(media.source_url);
  if (media.media_type === "pdf") return `${BACKEND}/api/pdf-thumb/${media.id}`;
  return null;
};

const TYPE_LABEL = {
  image: "IMG",
  video: "VID",
  pdf: "PDF",
  audio: "AUD",
  embed: "EMB",
};

function highlight(text, term) {
  if (!text || !term) return text;
  const t = term.toLowerCase();
  const lo = text.toLowerCase();
  const parts = [];
  let i = 0;
  while (i < text.length) {
    const idx = lo.indexOf(t, i);
    if (idx < 0) {
      parts.push({ text: text.slice(i), hit: false });
      break;
    }
    if (idx > i) parts.push({ text: text.slice(i, idx), hit: false });
    parts.push({ text: text.slice(idx, idx + t.length), hit: true });
    i = idx + t.length;
  }
  return parts.map((p, k) =>
    p.hit
      ? <mark key={k} className="hi-yellow">{p.text}</mark>
      : <span key={k}>{p.text}</span>
  );
}

export default function MediaCard({ media }) {
  const thumb = getThumb(media);
  const hasExcerpt = !!media.ocr_excerpt;
  return (
    <Link
      to={`/media/${media.id}`}
      data-testid={`media-card-${media.id}`}
      className="tile group"
    >
      <span className="tile-corner-badge">{media.ak_id}</span>
      <span className="tile-corner-badge-type">
        {TYPE_LABEL[media.media_type] || media.media_type.toUpperCase()}
      </span>

      {thumb ? (
        <img
          src={thumb}
          alt={media.title}
          className="tile-media"
          onError={(e) => { e.currentTarget.style.display = "none"; }}
        />
      ) : (
        <div className="tile-placeholder">
          {(media.title || media.ak_id).slice(0, 2).toUpperCase()}
        </div>
      )}

      {media.media_type === "video" && (
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10">
          <div className="w-14 h-14 border-[3px] border-black rounded-full flex items-center justify-center bg-white/90">
            <span className="text-black text-xl ml-1">▶</span>
          </div>
        </div>
      )}

      <div className={`tile-overlay ${hasExcerpt ? "tile-overlay-persistent" : ""}`}>
        <div className="mono text-[10px] uppercase tracking-[0.14em] text-white/80">
          /{media.dossier_slug}{media.year ? ` · ${media.year}` : ""}
        </div>
        <div className="display text-white text-lg leading-tight mt-1 line-clamp-2">
          {media.title}
        </div>
        {hasExcerpt && (
          <div
            data-testid={`ocr-excerpt-${media.id}`}
            className="mt-2 mono text-[11px] leading-snug text-white/90"
          >
            <span className="text-yellow mr-1">⌕</span>
            <span className="italic">{highlight(media.ocr_excerpt, media.ocr_match_term)}</span>
          </div>
        )}
      </div>
    </Link>
  );
}
